import Vue from 'vue';
import { captureException } from '@sentry/browser';
import pickBy from 'lodash/pickBy';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import assign from 'lodash/assign';

const store = Vue.observable({
  autoLoginUrl: null,
  currency: null,
  formUrl: null,
  siteUrl: null,
  amount: null,
  email: null,
  jwt: null,
  publishedSiteDomain: null,
  constructorDomain: null,
  wizard: {
    businessCategory: null,
    physicalAddress: null,
    contactNumber: null,
    servicingArea: null,
    clientType: null,
    schedule: '09:00 - 18:00',
    email: null,
    name: null,
    userAvatar: null,
    metadata: {
      referrer: window.location.href,
    },
  },
  paymentStatus: null,
  assign(data) {
    assign(this, data);
    return this;
  },
  loadFromLS() {
    try {
      if (typeof localStorage !== 'undefined') {
        const storeStr = localStorage.getItem('store');
        const storeData = JSON.parse(storeStr);
        assign(this, storeData);
      }
    } catch (err) {
      localStorage.removeItem('store');
      captureException(err);
    }
    return this;
  },
  saveToLS() {
    if (typeof localStorage !== 'undefined') {
      // filter unfilled fields, methods and substores
      const fieldCheck = value => isNumber(value) || isString(value);
      const storeData = pickBy(this, fieldCheck);
      localStorage.setItem('store', JSON.stringify(storeData));
    }
    return this;
  },
  get appMetricaData() {
    const wizardData = {
      ...this.wizard,
      referrer: this.wizard.metadata.referrer,
    };

    delete wizardData.metadata;

    return {
      ...wizardData,
      currency: this.currency,
      siteUrl: this.siteUrl,
      amount: this.amount,
      email: this.email,
      publishedSiteDomain: this.publishedSiteDomain,
      constructorDomain: this.constructorDomain,
    };
  },
});

store.loadFromLS();

export default store;
